import $ from 'jquery';
(function(){
    'use strict';
    // save news listing select and form variables
    var $newsSelectField = $('.news-listing').find('select'),
        newsSelectID = $newsSelectField.attr('id'),
        selectedRoot = $newsSelectField.children("option:selected").val(),
        $newsForm = $newsSelectField.closest('form'),
        actionUrl = $newsForm.attr('action');

    // news listing filter
    $newsSelectField.change(function() {
        selectedRoot = $(this).children("option:selected").val();
        // console.log(selectedRoot);
        $newsForm.submit();
    });

    // save current and total page values
    var $moreButtonWrapper = $newsForm.find('.load-more__wrapper'),
        $moreButtonLink = $moreButtonWrapper.find('.load-more__link'),
        $loadIcon = $moreButtonWrapper.find('.loading'),
        totalPagesElement = $moreButtonWrapper.siblings('.total-pages'),
        currentPageElement = $moreButtonWrapper.siblings('.current-page'),
        totalPagesText = totalPagesElement.text(),
        currentPageText = currentPageElement.text(),
        totalPagesValue = parseInt(totalPagesText),
        currentPageValue = parseInt(currentPageText),
        checkIntegerTotal = Number.isInteger(totalPagesValue),
        checkIntegerCurrent = Number.isInteger(currentPageValue),
        pageNumber = 1,
        nextPageElement = $moreButtonWrapper.siblings('.next-page-link'),
        nextPageLink = nextPageElement.find('a').attr('href');
        
    if (checkIntegerTotal && checkIntegerCurrent) {
        pageNumber = currentPageValue;
    }
    
    // display load-more button only when there are more than 1 pages and hide button on last page
    function displayMoreButton() {
        if (checkIntegerTotal && checkIntegerCurrent) {
            if (pageNumber < totalPagesValue) {
                $moreButtonLink.removeClass('hidden');
            } else {
                $moreButtonLink.addClass('hidden');
            }
        }
    }

    function displayMoreNews() {
        // generate action URL pattern
        var queryStringPattern = '',
            queryStringFinal = '';
            
        if (nextPageLink && nextPageLink !== undefined && nextPageLink !== null) {
            queryStringPattern = /result(.*?)=/,
            queryStringFinal = nextPageLink.match(queryStringPattern)[0];
        }
        
        if($moreButtonLink.length) {
            var buttonParent = $moreButtonLink.parent(),
                buttonSiblings = buttonParent.siblings('.feature-cards'),
                newsCards = buttonSiblings.children();
            
            if (newsSelectID === undefined || selectedRoot === undefined || newsSelectID === null || selectedRoot === null) {
                newsSelectID = '';
                selectedRoot = '';
            }

            $moreButtonLink.click(function(event) {
                event.preventDefault();
            // increase page number every time the button is clicked
                pageNumber = pageNumber + 1;
        
                if (pageNumber <= totalPagesValue) {
                    var generateFinalUrl = actionUrl + '?' + newsSelectID + '=' + selectedRoot + '&' + queryStringFinal + pageNumber;
                    // ajax call will only work in Matrix; will be blocked in local due to CORS
                    $.ajax(generateFinalUrl)
                        .done(function(page) {
                            // parse the response into object from string
                            var pageHTML = $($.parseHTML(page)),
                                $cardsMarkup = pageHTML.find('.feature-cards__wrapper').children();
                            // get news cards markup from the next page and append to current page
                            $cardsMarkup.appendTo(newsCards);
                            $loadIcon.addClass('hidden');
                            displayMoreButton();
                        })
                        .fail(function(jqXHR, textStatus) {
                            console.error('Load fail: ' + textStatus);
                        });
                        $loadIcon.removeClass('hidden');
                        $moreButtonLink.addClass('hidden');
                }
                
                $(this).blur();
                return false;
            });
        }
    }

    displayMoreButton();
    displayMoreNews();
    
}());
